import {Component, OnInit} from '@angular/core';
import {PropertyService} from "../../services/property.service";
import {UserService} from "../../services/user.service";
import {PropertyListInformationDto} from "../../dto/property.list.information.dto";
import {Router} from "@angular/router";
import {PropertyInitialSubject} from "../../subject/property.initial.subject";
import {Observable, tap, throwError} from "rxjs";
import {catchError} from "rxjs/operators";
import {PropertyInitialResponseDto} from "../../dto/property.initial.response.dto";
import {FlowModeSubject} from "../../subject/flow.mode.subject";
import {FlowMode} from "../../dto/enum/flow.mode.enum";

@Component({
    selector: 'app-property-list',
    templateUrl: './property-list.component.html',
    styleUrls: ['./property-list.component.scss']
})
export class PropertyListComponent implements OnInit {
    properties: PropertyListInformationDto[] = [];
    userName: string = '';
    offset: number = 0;
    pagezise: number = 6;
    loadButtonMore: boolean = false;

    constructor(
        private propertyService: PropertyService,
        private accountService: UserService,
        private router: Router,
        private propertyUpdateSubject: PropertyInitialSubject,
        private flowModeSubject: FlowModeSubject
    ) {}

    ngOnInit() {
        this.loadUserData();
        this.loadProperties();
    }

    loadUserData() {
        this.accountService.getUserInfo().subscribe(response => {
            if (response) {
                this.userName = response.accountName;
            }
        });
    }

    loadProperties() {
        this.propertyService.getProperties('COMPLETED_PROP',this.offset, this.pagezise).subscribe(response => {
            if (response) {
                this.properties = response.content;
                console.log(response);
                console.log('properties', this.properties);
                if(response.totalElements > 6){
                    this.loadButtonMore = true;
                }

            }
        });
    }

    editProperty(property: PropertyListInformationDto) {
        this.getPropertyInitialData(property.propertyId)
            .subscribe({
                next: () => {
                    this.flowModeSubject.setMode(FlowMode.EDIT); // editar: no avanza etapas, guarda con PUT
                    this.router.navigate(["/segments"]);
                },
                error: (err) => console.error('Error cargando propiedad:', err)
            });
    }


    viewProperty(property: PropertyListInformationDto) {
        console.log('Ver propiedad:', property);
        this.getPropertyInitialData(property.propertyId)
            .subscribe({
                next: () => this.router.navigate(["/property"]),
                error: (err) => console.error('Error cargando propiedad:', err)
            });
    }

    loadMore() {
        this.pagezise += 6;
        this.loadProperties();
    }

    isMobile() {
        return window.innerWidth <= 1024;
    }

    getPropertyInitialData(propertyId: number): Observable<PropertyInitialResponseDto> {
        return this.propertyService.getPropertyInitialData(propertyId).pipe(
            tap((response) => {
                if (response) {
                    this.propertyUpdateSubject.updateProperty(response);
                }
            }),
            catchError((error) => {
                console.error('Error al obtener los datos iniciales de la propiedad:', error);
                return throwError(() => error);
            })
        );
    }

}
